module.exports = __webpack_public_path__ + "img/bannerDesktop.a48d3f2d.webp";